var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{tag:"component",staticClass:"list"},_vm._l((_vm.elements),function(el){return _c('li',{staticClass:"list__item",class:el.class,domProps:{"innerHTML":_vm._s(el.text)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }